import { render, staticRenderFns } from "./HorizontalRule.vue?vue&type=template&id=70eb08f9&"
var script = {}
import style0 from "./HorizontalRule.vue?vue&type=style&index=0&id=70eb08f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports